require('./modifyMainPhoneStep1.scss');
// @vendors
const React = require('react');
const PropTypes = require('prop-types');

// @core
const { FormattedText } = require('core/i18n').i18n;

// @components
const { OKMessage } = require('commonsComponents/OKMessage');
const { RadioButtonGroup } = require('commonsComponents/radioButtonGroup');
const { RadioButton } = require('commonsComponents/radioButton');
const OKInformativeList = require('components/rebrand/OKInformativeList/OKInformativeList');
const OKInformativeListItem = require('components/rebrand/OKInformativeListItem/OKInformativeListItem');

// @ constants
const {
    FIRST_STEP,
} = require('constants/index');
const { mobilePhoneCodes } = require('constants/contactCenter/modifyMainPhone');

class ModifyMainPhoneStep1 extends React.Component {
    constructor(props) {
        super(props);
        this.handleRadioButtonsChange = this.handleRadioButtonsChange.bind(this);
    }

    buildMobilePhoneData() {
        const { immModifyMainPhone } = this.props;
        const phonesList = immModifyMainPhone.getIn(['mainContactPhoneData', 'listaDispositivos']).toJS();
        return phonesList.filter((phone) => {
            return mobilePhoneCodes.includes(phone.tipoUso);
        });
    }

    handleRadioButtonsChange(value) {
        const {setMainPhone} = this.props;
        setMainPhone(value)
    }

    buildRadioButtons() {
        const { immModifyMainPhone } = this.props;
        const mobilePhoneData = this.buildMobilePhoneData();
        const radioButtons = mobilePhoneData.map((phone, index) => {
            const label = phone.preferente === 'S' ? 'personalData-currentPhone' : `personalData-mobilePhoneLabel${index - 1}`;
            const radioButtonLabel = (
                <OKInformativeList
                    columns={1}
                >
                    <OKInformativeListItem title={label}>
                        {phone.detalleContacto}
                    </OKInformativeListItem>
                </OKInformativeList>
            );
            return (
                <RadioButton
                    key={index}
                    label={radioButtonLabel}
                    value={phone.numDispositivo}
                    disabled={false}
                    className="modify-main-phone-step-1__radio"
                />
            )
        });

        return (
            <RadioButtonGroup
                name="modifyMainPhoneStep1Radio"
                idPrefix="modifyMainPhoneStep1Radio"
                selectedValue={immModifyMainPhone.getIn(['steps', FIRST_STEP, 'selectedPhoneId'])}
                onChange={this.handleRadioButtonsChange}
            >
                {radioButtons}
            </RadioButtonGroup>
        );
    }
    render() {
        const radioButtons = this.buildRadioButtons();

        return (
            <article className="modify-main-phone-step-1">
                <header className="wizard_header">
                    <h1 className="wizard-step--vertical__title">
                        <FormattedText value="modifyMainPhone-step1Title"/>
                    </h1>
                </header>
                <OKMessage
                    type="informative"
                    extraClass="modify-main-phone-step-1__message"
                >
                    <FormattedText value="modifyMainPhone-step1blockInfo" />
                    &nbsp;
                </OKMessage>
                {radioButtons}
            </article>
        );
    }
}

ModifyMainPhoneStep1.propTypes = {
    immModifyMainPhone: PropTypes.object.isRequired,
    setMainPhone: PropTypes.func.isRequired
};

module.exports = ModifyMainPhoneStep1;
